import moment from "moment";
import TradeCell from "./TradeCell";

const formatDateTime = (v) =>
    v ? moment(v).format("DD-MM-YYYY, hh:mm:ss A") : "---";
const yes_no = (v) => (v ? "Yes" : "No");

/** API may send either flag */
const scalpingProcessed = (t) => t?.isAlreadyDeducted ?? t?.isRBScalpingDeducted;

export const mapRvTradeData = (data) => ({
    tableData: data?.rvTradeDetails?.map((item, index) => {
        const f = item?.firstTrade;
        const s = item?.secondTrade;
        return {
            id: index,
            action: <TradeCell first={f?.action} second={s?.action} firstAction={f?.action} secondAction={s?.action} />,
            symbol: <TradeCell first={f?.symbol} second={s?.symbol} firstAction={f?.action} secondAction={s?.action} />,
            totalCloseVolume: <TradeCell first={f?.totalCloseVolume} second={s?.totalCloseVolume} firstAction={f?.action} secondAction={s?.action} />,
            openPrice: <TradeCell first={f?.openPrice} second={s?.openPrice} firstAction={f?.action} secondAction={s?.action} />,
            closePrice: <TradeCell first={f?.closePrice} second={s?.closePrice} firstAction={f?.action} secondAction={s?.action} />,
            openTime: <TradeCell first={formatDateTime(f?.openTime)} second={formatDateTime(s?.openTime)} firstAction={f?.action} secondAction={s?.action} />,
            closeTime: <TradeCell first={formatDateTime(f?.closeTime)} second={formatDateTime(s?.closeTime)} firstAction={f?.action} secondAction={s?.action} />,
            netProfit: <TradeCell first={f?.netProfit} second={s?.netProfit} firstAction={f?.action} secondAction={s?.action} />,
            positionId: <TradeCell first={f?.positionId} second={s?.positionId} firstAction={f?.action} secondAction={s?.action} />,
            closeDealsCount: <TradeCell first={f?.closeDealsCount} second={s?.closeDealsCount} firstAction={f?.action} secondAction={s?.action} />,
            isAlreadyDeducted: <TradeCell first={yes_no(scalpingProcessed(f))} second={yes_no(scalpingProcessed(s))} firstAction={f?.action} secondAction={s?.action} />,
            message: <TradeCell first={f?.message} second={s?.message} firstAction={f?.action} secondAction={s?.action} />,
        };
    }),
    summary: {
        totalProfit: data?.profit || 0,
        totalLoss: data?.loss || 0,
        netProfit: data?.netProfit || 0
    }
});
